var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Alert, Autocomplete, Box, Button, Card, CardContent, CircularProgress, Stack, TextField, Typography, } from "@mui/material";
import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import { useAutocompleteVenues, useCreateVenue, useRetrieveVenueByGooglePlaceId, } from "../api/VenueApiProvider";
var CreateVenue = function () {
    var navigate = useNavigate();
    var _a = __read(useState({
        googlePlaceId: "",
    }), 2), formData = _a[0], setFormData = _a[1];
    var _b = __read(useState(""), 2), autocompleteQuery = _b[0], setAutocompleteQuery = _b[1];
    var _c = __read(useState(null), 2), selectedOption = _c[0], setSelectedOption = _c[1];
    var _d = __read(useState(undefined), 2), existingVenue = _d[0], setExistingVenue = _d[1];
    var _e = __read(useState(false), 2), isSubmitting = _e[0], setIsSubmitting = _e[1];
    // API hooks
    var _f = useAutocompleteVenues({
        query: autocompleteQuery,
        enabled: autocompleteQuery.trim().length > 2,
    }), autocompleteOptions = _f.data, isAutocompleteLoading = _f.isLoading;
    var _g = useRetrieveVenueByGooglePlaceId({
        googlePlaceId: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.placeId,
        enabled: !!(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.placeId),
    }), existingVenueData = _g.data, isCheckingExisting = _g.isLoading;
    var createVenueMutation = useCreateVenue({
        onSuccess: function (data) {
            navigate("/venues/".concat(data.data.id));
        },
        onError: function (error) {
            setIsSubmitting(false);
            console.error("Failed to create venue:", error);
            alert("Failed to create venue. Please try again.");
        },
    });
    // Update existing venue when we get data
    React.useEffect(function () {
        setExistingVenue(existingVenueData);
    }, [existingVenueData]);
    var handleOptionSelect = function (event, value) {
        setSelectedOption(value);
        if (value) {
            setFormData({ googlePlaceId: value.placeId });
        }
        else {
            setFormData({ googlePlaceId: "" });
            setExistingVenue(undefined);
        }
    };
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            e.preventDefault();
            if (!selectedOption || existingVenue) {
                return [2 /*return*/];
            }
            setIsSubmitting(true);
            createVenueMutation.mutate(formData);
            return [2 /*return*/];
        });
    }); };
    return (_jsx(Box, { maxWidth: "md", mx: "auto", p: 3, children: _jsx(Card, { children: _jsxs(CardContent, { children: [_jsx(Typography, { variant: "h4", component: "h1", mb: 2, children: "Add Venue to Log.Soccer" }), _jsx(Alert, { severity: "info", sx: { mb: 3 }, children: _jsxs(Typography, { variant: "body2", component: "div", children: [_jsx("strong", { children: "Important:" }), " Each venue exists only once in our system. If your home pitch or regular venue isn't listed, please add it here for everyone to use.", _jsx("br", {}), _jsx("br", {}), "Start by searching for your venue below - we'll check if it already exists."] }) }), _jsxs(Box, { component: "form", onSubmit: handleSubmit, children: [_jsxs(Stack, { spacing: 3, children: [_jsxs(Box, { children: [_jsx(Typography, { variant: "h6", gutterBottom: true, children: "Search for Venue" }), _jsx(Autocomplete, { options: (autocompleteOptions === null || autocompleteOptions === void 0 ? void 0 : autocompleteOptions.predictions) || [], getOptionLabel: function (option) { return option.description; }, renderOption: function (props, option) { return (_jsx(Box, __assign({ component: "li" }, props, { children: _jsxs(Box, { children: [_jsx(Typography, { variant: "body1", children: option.mainText }), option.secondaryText && (_jsx(Typography, { variant: "body2", color: "text.secondary", children: option.secondaryText }))] }) }))); }, inputValue: autocompleteQuery, onInputChange: function (event, newInputValue) {
                                                    setAutocompleteQuery(newInputValue);
                                                }, value: selectedOption, onChange: handleOptionSelect, loading: isAutocompleteLoading && autocompleteQuery.trim().length > 2, loadingText: "Searching venues...", noOptionsText: "No venues found. Try different search terms.", renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { placeholder: "Start typing venue name (e.g., 'Wembley Stadium', 'Crystal Palace FC')...", helperText: "Search Google Places for soccer venues, stadiums, and training facilities", InputProps: __assign(__assign({}, params.InputProps), { endAdornment: (_jsxs(_Fragment, { children: [isAutocompleteLoading &&
                                                                    autocompleteQuery.trim().length > 2 ? (_jsx(CircularProgress, { color: "inherit", size: 20 })) : null, params.InputProps.endAdornment] })) }) }))); } })] }), selectedOption && (_jsx(Box, { children: isCheckingExisting ? (_jsx(Alert, { severity: "info", children: _jsx(Typography, { variant: "body2", component: "div", children: "Checking if venue already exists..." }) })) : existingVenue ? (_jsx(Alert, { severity: "warning", children: _jsxs(Typography, { variant: "body2", component: "div", children: [_jsx("strong", { children: "This venue already exists!" }), _jsx("br", {}), _jsx("strong", { children: existingVenue.name }), " at", " ", existingVenue.formattedAddress, _jsx("br", {}), _jsx("br", {}), _jsx(Button, { variant: "outlined", size: "small", color: "primary", onClick: function () {
                                                            return navigate("/venues/".concat(existingVenue.id));
                                                        }, sx: { mt: 1 }, children: "View Existing Venue \u2192" })] }) })) : (_jsx(Alert, { severity: "success", children: _jsxs(Typography, { variant: "body2", component: "div", children: [_jsx("strong", { children: selectedOption.mainText }), " can be added to our database."] }) })) }))] }), _jsxs(Box, { display: "flex", justifyContent: "flex-end", gap: 2, mt: 4, children: [_jsx(Button, { type: "button", variant: "outlined", color: "inherit", onClick: function () { return window.history.back(); }, disabled: isSubmitting, children: "Cancel" }), _jsx(Button, { type: "submit", variant: "contained", color: "primary", size: "large", disabled: !selectedOption || !!existingVenue || isSubmitting, startIcon: isSubmitting ? _jsx(CircularProgress, { size: 16 }) : null, children: isSubmitting ? "Adding to Log.Soccer..." : "Add to Log.Soccer" })] })] })] }) }) }));
};
export default CreateVenue;
